import { render, staticRenderFns } from "./BusinessDeleteConfirmationModal.vue?vue&type=template&id=96191fc6"
import script from "./BusinessDeleteConfirmationModal.vue?vue&type=script&lang=js"
export * from "./BusinessDeleteConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports